import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAdminAuth } from '../../hooks/useAdminAuth';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

const AdminRoutes = () => {
  const { isAuthenticated, checkAuth } = useAdminAuth();

  // Componente para rotas protegidas
  const ProtectedRoute = ({ children }) => {
    // Verifica se o usuário está autenticado
    const authStatus = checkAuth();
    
    // Se não estiver autenticado, redireciona para o login
    if (!authStatus) {
      return <Navigate to="/admin/login" replace />;
    }
    
    // Se estiver autenticado, renderiza o conteúdo protegido
    return children;
  };
  
  return (
    <Routes>
      <Route 
        path="login" 
        element={
          isAuthenticated ? (
            <Navigate to="/admin/panel" replace />
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <AdminLogin />
            </motion.div>
          )
        } 
      />
      
      <Route 
        path="panel" 
        element={
          <ProtectedRoute>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <AdminPanel />
            </motion.div>
          </ProtectedRoute>
        } 
      />
      
      {/* Rota padrão - redireciona para o painel se autenticado, ou para login caso contrário */}
      <Route 
        path="/" 
        element={
          isAuthenticated ? (
            <Navigate to="/admin/panel" replace />
          ) : (
            <Navigate to="/admin/login" replace />
          )
        } 
      />
      
      {/* Rota para capturar qualquer outra rota não definida na área admin */}
      <Route 
        path="*" 
        element={
          <Navigate to="/admin" replace />
        } 
      />
    </Routes>
  );
};

export default AdminRoutes; 